import { TreatmentFiles } from './treatment-file.model';

export interface TreatmentAiJobStatusChangeEvent {
    treatmentId: string;
    jobId: string;
    status: TreatmentAiJobStatus;
    progressPercent: number;
    progressDescription?: string;
    error?: TreatmentAiJobError | null;
    createdDate: string | Date;
    files?: TreatmentFiles | null;
    isTriggerManually: boolean;
    isKpsOnly?: boolean;
    undercutDegree?: number | null;
}

export interface TreatmentAiJobError {
    code?: string | null;
    detail?: string | null;
    level?: TreatmentAiJobErrorLevel | null;
}

export enum TreatmentAiJobErrorLevel {
    warning = 1,
    fatal = 2,
}

export enum TreatmentAiJobStatus {
    none = 0,
    enqueued = 1,
    running = 2,
    success = 3,
    error = 5,
}
